@if (folderSelezionato) {
  <div class="folder-tool">
    <div class="searchbar-and-filtri">
      <!-- AGGIUNGERE RICERCA E FILTRI -->
      <app-search-and-filtri-documenti
        visualizza="SEARCHBAR"
        (isSearchBarOpen)="isSearchBarOpen($event)"
      ></app-search-and-filtri-documenti>
      @if (showFiltri) {
        <div class="filtri">
          <app-search-and-filtri-documenti visualizza="FILTRI"></app-search-and-filtri-documenti>
        </div>
      }
    </div>
  </div>

  <div class="cnt-card-files">
    <!-- DRANG AND DROP DEI FILE NEL CONTAINER DA DESKTOP -->
    @if (folderSelezionato && !folderSelezionato.locked) {
      <app-drag-drop-file-uploader
        (dropped)="onFileDropped($event)"
        (draggingChanged)="onDraggingStateChange($event)"
      ></app-drag-drop-file-uploader>
    }

    <ng-scrollbar #scrollbarListaFile>
      <div class="cnt-card">
        <!-- F O L D E R S -->
        <div class="cnt-folders">
          @for (folder of folderSelezionato.folders; track $index) {
            <mat-card
              class="folder-card"
              appearance="outlined"
              (dblclick)="onFolderDblClick(folder)"
            >
              <div class="folder">
                <mat-icon>
                  {{ hasSottoCartelle(folder) || hasFile(folder) ? 'folder' : 'folder_open' }}
                </mat-icon>
                <mat-card-title [matTooltip]="folder.name">{{ folder.name }}</mat-card-title>
              </div>

              <!-- MENU FOLDER ON HOVER-->
              <div class="menu-btn">
                <app-menu-folder [folderSelezionato]="folder" [isFolder]="true"></app-menu-folder>
              </div>
            </mat-card>
          }
        </div>
        <!-- F I L E S -->
        <div class="file-grid">
          @for (file of folderFiles; track $index) {
            <app-file-card-documenti [file]="file"></app-file-card-documenti>
          }
        </div>
      </div>
    </ng-scrollbar>
    @if (!isDragging() && isFolderValidWithoutFile()) {
      <div class="drop-files-messages">
        <mat-icon>cloud_upload</mat-icon>
        <div>Trascinali i tuoi file qui per aggiungerli alla lista</div>
      </div>
    }

    @if (isFolderLockedAndEmpty()) {
      <div class="drop-files-messages">
        <mat-icon>folder</mat-icon>
        <div>Configura il tuo spazio creando la prima cartella</div>
      </div>
    }
  </div>
  <span class="totali"> {{ folderFiles.length }} elementi caricati</span>
}
